module.exports = __webpack_public_path__ + "img/banner0.db0545a5.jpg";